import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import PageHeader from '../../shared/PageHeader';
import SearchContent from './SearchContent';
import BlogSidebar from '../sidebar/BlogSidebar';

function Search(props) {
    const { layout, sidebarPosition } = props;
    const ControlsTranslations = useSelector((state) => state.translations.ControlsTranslations);

    let content;
    if (layout === 'classic') {
        const sidebar = <BlogSidebar position={sidebarPosition} />;

        let sidebarStart;
        let sidebarEnd;

        if (sidebarPosition === 'start') {
            sidebarStart = <div className="col-12 col-lg-3 order-1 order-lg-0">{sidebar}</div>;
        }
        if (sidebarPosition === 'end') {
            sidebarEnd = <div className="col-12 col-lg-3">{sidebar}</div>;
        }
        content = (
            <div className="row">
                {sidebarStart}
                <div className="col-12 col-lg-9 search-section">
                    <SearchContent layout={layout} />
                </div>
                {sidebarEnd}
            </div>
        );
    } else if (layout === 'full') {
        content = (
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8 col-xl-8">
                    <SearchContent layout={layout} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="search-header">
                <PageHeader header={ControlsTranslations.searchName} shfaqbreadcrumb={false} />
            </div>

            <div className="container">{content}</div>

        </React.Fragment>
    );
}

Search.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
    sidebarPosition: PropTypes.oneOf(['start', 'end']),
};

Search.defaultProps = {
    layout: 'classic',
    sidebarPosition: 'end',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
    translations: state.translations,
});

export default connect(mapStateToProps)(Search);
